//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class PonderTasksClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    health(): Observable<void> {
        let url_ = this.baseUrl + "/health";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHealth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHealth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processHealth(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    otherAdvancedSearchMagic(): Observable<MagicAdvancedSearchFile> {
        let url_ = this.baseUrl + "/other/advanced-search/magic";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOtherAdvancedSearchMagic(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOtherAdvancedSearchMagic(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MagicAdvancedSearchFile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MagicAdvancedSearchFile>;
        }));
    }

    protected processOtherAdvancedSearchMagic(response: HttpResponseBase): Observable<MagicAdvancedSearchFile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MagicAdvancedSearchFile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MagicAdvancedSearchFile>(null as any);
    }

    /**
     * @return OK
     */
    tasksDescribe(): Observable<DescribeTasksResponse> {
        let url_ = this.baseUrl + "/tasks/describe";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTasksDescribe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTasksDescribe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DescribeTasksResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DescribeTasksResponse>;
        }));
    }

    protected processTasksDescribe(response: HttpResponseBase): Observable<DescribeTasksResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DescribeTasksResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DescribeTasksResponse>(null as any);
    }

    /**
     * @param taskName (optional) 
     * @return OK
     */
    tasksDescribeTask(taskName: string | undefined): Observable<DescribeTaskResponse> {
        let url_ = this.baseUrl + "/tasks/describe/task?";
        if (taskName === null)
            throw new Error("The parameter 'taskName' cannot be null.");
        else if (taskName !== undefined)
            url_ += "taskName=" + encodeURIComponent("" + taskName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTasksDescribeTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTasksDescribeTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DescribeTaskResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DescribeTaskResponse>;
        }));
    }

    protected processTasksDescribeTask(response: HttpResponseBase): Observable<DescribeTaskResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DescribeTaskResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DescribeTaskResponse>(null as any);
    }

    /**
     * @return OK
     */
    tasksSummary(): Observable<GetRecentTasksResponse> {
        let url_ = this.baseUrl + "/tasks/summary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTasksSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTasksSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRecentTasksResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRecentTasksResponse>;
        }));
    }

    protected processTasksSummary(response: HttpResponseBase): Observable<GetRecentTasksResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRecentTasksResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRecentTasksResponse>(null as any);
    }

    /**
     * @return OK
     */
    tasksRunPost(body: RunTaskRequest): Observable<RunTaskResponse> {
        let url_ = this.baseUrl + "/tasks/run";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTasksRunPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTasksRunPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RunTaskResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RunTaskResponse>;
        }));
    }

    protected processTasksRunPost(response: HttpResponseBase): Observable<RunTaskResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RunTaskResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RunTaskResponse>(null as any);
    }

    /**
     * @param taskRunId (optional) 
     * @return OK
     */
    tasksRunGet(taskRunId: string | undefined): Observable<GetTaskRunResponse> {
        let url_ = this.baseUrl + "/tasks/run?";
        if (taskRunId === null)
            throw new Error("The parameter 'taskRunId' cannot be null.");
        else if (taskRunId !== undefined)
            url_ += "taskRunId=" + encodeURIComponent("" + taskRunId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTasksRunGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTasksRunGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTaskRunResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTaskRunResponse>;
        }));
    }

    protected processTasksRunGet(response: HttpResponseBase): Observable<GetTaskRunResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTaskRunResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTaskRunResponse>(null as any);
    }

    /**
     * @param taskRunId (optional) 
     * @return OK
     */
    tasksRunEvents(taskRunId: string | undefined): Observable<GetTaskRunEventsResponse> {
        let url_ = this.baseUrl + "/tasks/run/events?";
        if (taskRunId === null)
            throw new Error("The parameter 'taskRunId' cannot be null.");
        else if (taskRunId !== undefined)
            url_ += "taskRunId=" + encodeURIComponent("" + taskRunId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTasksRunEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTasksRunEvents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTaskRunEventsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTaskRunEventsResponse>;
        }));
    }

    protected processTasksRunEvents(response: HttpResponseBase): Observable<GetTaskRunEventsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTaskRunEventsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTaskRunEventsResponse>(null as any);
    }

    /**
     * @param taskName (optional) 
     * @param start (optional) 
     * @param count (optional) 
     * @return OK
     */
    tasksHistory(taskName: string | undefined, start: number | undefined, count: number | undefined): Observable<GetTaskHistoryResponse> {
        let url_ = this.baseUrl + "/tasks/history?";
        if (taskName === null)
            throw new Error("The parameter 'taskName' cannot be null.");
        else if (taskName !== undefined)
            url_ += "taskName=" + encodeURIComponent("" + taskName) + "&";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTasksHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTasksHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTaskHistoryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTaskHistoryResponse>;
        }));
    }

    protected processTasksHistory(response: HttpResponseBase): Observable<GetTaskHistoryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTaskHistoryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTaskHistoryResponse>(null as any);
    }

    /**
     * @param taskName (optional) 
     * @return OK
     */
    tasksPredefinedGet(taskName: string | undefined): Observable<GetPredefinedTasksResponse> {
        let url_ = this.baseUrl + "/tasks/predefined?";
        if (taskName === null)
            throw new Error("The parameter 'taskName' cannot be null.");
        else if (taskName !== undefined)
            url_ += "taskName=" + encodeURIComponent("" + taskName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTasksPredefinedGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTasksPredefinedGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPredefinedTasksResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPredefinedTasksResponse>;
        }));
    }

    protected processTasksPredefinedGet(response: HttpResponseBase): Observable<GetPredefinedTasksResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPredefinedTasksResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPredefinedTasksResponse>(null as any);
    }

    /**
     * @return OK
     */
    tasksPredefinedPost(body: SavePredefinedTaskRequest): Observable<TaskResponse> {
        let url_ = this.baseUrl + "/tasks/predefined";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTasksPredefinedPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTasksPredefinedPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskResponse>;
        }));
    }

    protected processTasksPredefinedPost(response: HttpResponseBase): Observable<TaskResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskResponse>(null as any);
    }

    /**
     * @return OK
     */
    tasksScheduleTaskPost(body: CreateTaskScheduleRequest): Observable<CreateTaskScheduleResponse> {
        let url_ = this.baseUrl + "/tasks/schedule/task";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTasksScheduleTaskPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTasksScheduleTaskPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateTaskScheduleResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateTaskScheduleResponse>;
        }));
    }

    protected processTasksScheduleTaskPost(response: HttpResponseBase): Observable<CreateTaskScheduleResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateTaskScheduleResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateTaskScheduleResponse>(null as any);
    }

    /**
     * @return OK
     */
    tasksScheduleTaskPatch(body: UpdateTaskScheduleRequest): Observable<TaskResponse> {
        let url_ = this.baseUrl + "/tasks/schedule/task";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTasksScheduleTaskPatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTasksScheduleTaskPatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskResponse>;
        }));
    }

    protected processTasksScheduleTaskPatch(response: HttpResponseBase): Observable<TaskResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskResponse>(null as any);
    }

    /**
     * @param scheduleId (optional) 
     * @return OK
     */
    tasksScheduleTaskDelete(scheduleId: string | undefined): Observable<TaskResponse> {
        let url_ = this.baseUrl + "/tasks/schedule/task?";
        if (scheduleId === null)
            throw new Error("The parameter 'scheduleId' cannot be null.");
        else if (scheduleId !== undefined)
            url_ += "scheduleId=" + encodeURIComponent("" + scheduleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTasksScheduleTaskDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTasksScheduleTaskDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskResponse>;
        }));
    }

    protected processTasksScheduleTaskDelete(response: HttpResponseBase): Observable<TaskResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskResponse>(null as any);
    }

    /**
     * @param taskName (optional) 
     * @return OK
     */
    tasksListScheduleTask(taskName: string | undefined): Observable<ListTaskSchedulesResponse> {
        let url_ = this.baseUrl + "/tasks/list/schedule/task?";
        if (taskName === null)
            throw new Error("The parameter 'taskName' cannot be null.");
        else if (taskName !== undefined)
            url_ += "taskName=" + encodeURIComponent("" + taskName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTasksListScheduleTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTasksListScheduleTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListTaskSchedulesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListTaskSchedulesResponse>;
        }));
    }

    protected processTasksListScheduleTask(response: HttpResponseBase): Observable<ListTaskSchedulesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListTaskSchedulesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListTaskSchedulesResponse>(null as any);
    }

    /**
     * @return OK
     */
    userCollectionImport(body: ImportCollectionRequest): Observable<ImportCollectionResponse> {
        let url_ = this.baseUrl + "/user/collection/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserCollectionImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserCollectionImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportCollectionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportCollectionResponse>;
        }));
    }

    protected processUserCollectionImport(response: HttpResponseBase): Observable<ImportCollectionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportCollectionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImportCollectionResponse>(null as any);
    }

    /**
     * @return OK
     */
    userCollectionImportResults(): Observable<GetImportUserCollectionResultsResponse> {
        let url_ = this.baseUrl + "/user/collection/import/results";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserCollectionImportResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserCollectionImportResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetImportUserCollectionResultsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetImportUserCollectionResultsResponse>;
        }));
    }

    protected processUserCollectionImportResults(response: HttpResponseBase): Observable<GetImportUserCollectionResultsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetImportUserCollectionResultsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetImportUserCollectionResultsResponse>(null as any);
    }

    /**
     * @return OK
     */
    userCollectionExport(body: ExportCollectionRequest): Observable<ExportCollectionResponse> {
        let url_ = this.baseUrl + "/user/collection/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserCollectionExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserCollectionExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportCollectionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportCollectionResponse>;
        }));
    }

    protected processUserCollectionExport(response: HttpResponseBase): Observable<ExportCollectionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportCollectionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExportCollectionResponse>(null as any);
    }

    /**
     * @return OK
     */
    userCollectionExportResults(): Observable<GetExportUserCollectionResultsResponse> {
        let url_ = this.baseUrl + "/user/collection/export/results";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserCollectionExportResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserCollectionExportResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetExportUserCollectionResultsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetExportUserCollectionResultsResponse>;
        }));
    }

    protected processUserCollectionExportResults(response: HttpResponseBase): Observable<GetExportUserCollectionResultsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetExportUserCollectionResultsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetExportUserCollectionResultsResponse>(null as any);
    }
}

export class CollectionExportPart implements ICollectionExportPart {
    game!: GameType;
    itemType!: ItemType;
    successCount?: number;
    failureCount?: number;
    failures?: string[] | undefined;
    artifactUrl?: string | undefined;
    artifactExpiresAt?: Date | undefined;

    [key: string]: any;

    constructor(data?: ICollectionExportPart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.game = _data["game"];
            this.itemType = _data["itemType"];
            this.successCount = _data["successCount"];
            this.failureCount = _data["failureCount"];
            if (Array.isArray(_data["failures"])) {
                this.failures = [] as any;
                for (let item of _data["failures"])
                    this.failures!.push(item);
            }
            this.artifactUrl = _data["artifactUrl"];
            this.artifactExpiresAt = _data["artifactExpiresAt"] ? new Date(_data["artifactExpiresAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CollectionExportPart {
        data = typeof data === 'object' ? data : {};
        let result = new CollectionExportPart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["game"] = this.game;
        data["itemType"] = this.itemType;
        data["successCount"] = this.successCount;
        data["failureCount"] = this.failureCount;
        if (Array.isArray(this.failures)) {
            data["failures"] = [];
            for (let item of this.failures)
                data["failures"].push(item);
        }
        data["artifactUrl"] = this.artifactUrl;
        data["artifactExpiresAt"] = this.artifactExpiresAt ? this.artifactExpiresAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICollectionExportPart {
    game: GameType;
    itemType: ItemType;
    successCount?: number;
    failureCount?: number;
    failures?: string[] | undefined;
    artifactUrl?: string | undefined;
    artifactExpiresAt?: Date | undefined;

    [key: string]: any;
}

export class CollectionExportResult implements ICollectionExportResult {
    importedAt!: Date;
    collectionExport?: CollectionExportPart | undefined;
    collectionType!: ExternalCollectionType;

    [key: string]: any;

    constructor(data?: ICollectionExportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.importedAt = _data["importedAt"] ? new Date(_data["importedAt"].toString()) : <any>undefined;
            this.collectionExport = _data["collectionExport"] ? CollectionExportPart.fromJS(_data["collectionExport"]) : <any>undefined;
            this.collectionType = _data["collectionType"];
        }
    }

    static fromJS(data: any): CollectionExportResult {
        data = typeof data === 'object' ? data : {};
        let result = new CollectionExportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["importedAt"] = this.importedAt ? this.importedAt.toISOString() : <any>undefined;
        data["collectionExport"] = this.collectionExport ? this.collectionExport.toJSON() : <any>undefined;
        data["collectionType"] = this.collectionType;
        return data;
    }
}

export interface ICollectionExportResult {
    importedAt: Date;
    collectionExport?: CollectionExportPart | undefined;
    collectionType: ExternalCollectionType;

    [key: string]: any;
}

export class CollectionImportPart implements ICollectionImportPart {
    game!: GameType;
    itemType!: ItemType;
    successCount?: number;
    failureCount?: number;
    skipCount?: number;
    failures?: string[] | undefined;

    [key: string]: any;

    constructor(data?: ICollectionImportPart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.game = _data["game"];
            this.itemType = _data["itemType"];
            this.successCount = _data["successCount"];
            this.failureCount = _data["failureCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["failures"])) {
                this.failures = [] as any;
                for (let item of _data["failures"])
                    this.failures!.push(item);
            }
        }
    }

    static fromJS(data: any): CollectionImportPart {
        data = typeof data === 'object' ? data : {};
        let result = new CollectionImportPart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["game"] = this.game;
        data["itemType"] = this.itemType;
        data["successCount"] = this.successCount;
        data["failureCount"] = this.failureCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.failures)) {
            data["failures"] = [];
            for (let item of this.failures)
                data["failures"].push(item);
        }
        return data;
    }
}

export interface ICollectionImportPart {
    game: GameType;
    itemType: ItemType;
    successCount?: number;
    failureCount?: number;
    skipCount?: number;
    failures?: string[] | undefined;

    [key: string]: any;
}

export class CollectionImportResult implements ICollectionImportResult {
    collectionType!: ExternalCollectionType;
    importedAt!: Date;
    collectionImports?: CollectionImportPart[] | undefined;
    deckImports?: DeckImportPart[] | undefined;
    error?: string | undefined;

    [key: string]: any;

    constructor(data?: ICollectionImportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.collectionType = _data["collectionType"];
            this.importedAt = _data["importedAt"] ? new Date(_data["importedAt"].toString()) : <any>undefined;
            if (Array.isArray(_data["collectionImports"])) {
                this.collectionImports = [] as any;
                for (let item of _data["collectionImports"])
                    this.collectionImports!.push(CollectionImportPart.fromJS(item));
            }
            if (Array.isArray(_data["deckImports"])) {
                this.deckImports = [] as any;
                for (let item of _data["deckImports"])
                    this.deckImports!.push(DeckImportPart.fromJS(item));
            }
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): CollectionImportResult {
        data = typeof data === 'object' ? data : {};
        let result = new CollectionImportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["collectionType"] = this.collectionType;
        data["importedAt"] = this.importedAt ? this.importedAt.toISOString() : <any>undefined;
        if (Array.isArray(this.collectionImports)) {
            data["collectionImports"] = [];
            for (let item of this.collectionImports)
                data["collectionImports"].push(item.toJSON());
        }
        if (Array.isArray(this.deckImports)) {
            data["deckImports"] = [];
            for (let item of this.deckImports)
                data["deckImports"].push(item.toJSON());
        }
        data["error"] = this.error;
        return data;
    }
}

export interface ICollectionImportResult {
    collectionType: ExternalCollectionType;
    importedAt: Date;
    collectionImports?: CollectionImportPart[] | undefined;
    deckImports?: DeckImportPart[] | undefined;
    error?: string | undefined;

    [key: string]: any;
}

export class CreateTaskScheduleRequest implements ICreateTaskScheduleRequest {
    taskName!: string;
    taskDefinitionName!: string;
    cronSchedule!: string;
    enabled!: boolean;

    [key: string]: any;

    constructor(data?: ICreateTaskScheduleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.taskName = _data["taskName"];
            this.taskDefinitionName = _data["taskDefinitionName"];
            this.cronSchedule = _data["cronSchedule"];
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): CreateTaskScheduleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTaskScheduleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["taskName"] = this.taskName;
        data["taskDefinitionName"] = this.taskDefinitionName;
        data["cronSchedule"] = this.cronSchedule;
        data["enabled"] = this.enabled;
        return data;
    }
}

export interface ICreateTaskScheduleRequest {
    taskName: string;
    taskDefinitionName: string;
    cronSchedule: string;
    enabled: boolean;

    [key: string]: any;
}

export class CreateTaskScheduleResponse implements ICreateTaskScheduleResponse {
    schedule?: TaskSchedule | undefined;
    success?: boolean;
    error?: string | undefined;

    [key: string]: any;

    constructor(data?: ICreateTaskScheduleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.schedule = _data["schedule"] ? TaskSchedule.fromJS(_data["schedule"]) : <any>undefined;
            this.success = _data["success"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): CreateTaskScheduleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTaskScheduleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["schedule"] = this.schedule ? this.schedule.toJSON() : <any>undefined;
        data["success"] = this.success;
        data["error"] = this.error;
        return data;
    }
}

export interface ICreateTaskScheduleResponse {
    schedule?: TaskSchedule | undefined;
    success?: boolean;
    error?: string | undefined;

    [key: string]: any;
}

export class DeckImportPart implements IDeckImportPart {
    game!: GameType;
    deckGroup!: string;
    deckName!: string;
    success!: boolean;

    [key: string]: any;

    constructor(data?: IDeckImportPart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.game = _data["game"];
            this.deckGroup = _data["deckGroup"];
            this.deckName = _data["deckName"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): DeckImportPart {
        data = typeof data === 'object' ? data : {};
        let result = new DeckImportPart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["game"] = this.game;
        data["deckGroup"] = this.deckGroup;
        data["deckName"] = this.deckName;
        data["success"] = this.success;
        return data;
    }
}

export interface IDeckImportPart {
    game: GameType;
    deckGroup: string;
    deckName: string;
    success: boolean;

    [key: string]: any;
}

export class DescribeTaskResponse implements IDescribeTaskResponse {
    task?: TaskDescription2 | undefined;
    success?: boolean;
    error?: string | undefined;

    [key: string]: any;

    constructor(data?: IDescribeTaskResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.task = _data["task"] ? TaskDescription2.fromJS(_data["task"]) : <any>undefined;
            this.success = _data["success"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): DescribeTaskResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DescribeTaskResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["task"] = this.task ? this.task.toJSON() : <any>undefined;
        data["success"] = this.success;
        data["error"] = this.error;
        return data;
    }
}

export interface IDescribeTaskResponse {
    task?: TaskDescription2 | undefined;
    success?: boolean;
    error?: string | undefined;

    [key: string]: any;
}

export class DescribeTasksResponse implements IDescribeTasksResponse {
    tasks?: TaskDescription[] | undefined;
    success?: boolean;
    error?: string | undefined;

    [key: string]: any;

    constructor(data?: IDescribeTasksResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(TaskDescription.fromJS(item));
            }
            this.success = _data["success"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): DescribeTasksResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DescribeTasksResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item.toJSON());
        }
        data["success"] = this.success;
        data["error"] = this.error;
        return data;
    }
}

export interface IDescribeTasksResponse {
    tasks?: TaskDescription[] | undefined;
    success?: boolean;
    error?: string | undefined;

    [key: string]: any;
}

export class ExportCollectionRequest implements IExportCollectionRequest {
    game!: GameType;
    collectionType!: ExternalCollectionType;

    [key: string]: any;

    constructor(data?: IExportCollectionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.game = _data["game"];
            this.collectionType = _data["collectionType"];
        }
    }

    static fromJS(data: any): ExportCollectionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExportCollectionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["game"] = this.game;
        data["collectionType"] = this.collectionType;
        return data;
    }
}

export interface IExportCollectionRequest {
    game: GameType;
    collectionType: ExternalCollectionType;

    [key: string]: any;
}

export class ExportCollectionResponse implements IExportCollectionResponse {
    status?: UserCollectionExportTaskStatus | undefined;
    success?: boolean;
    error?: string | undefined;

    [key: string]: any;

    constructor(data?: IExportCollectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.status = _data["status"] ? UserCollectionExportTaskStatus.fromJS(_data["status"]) : <any>undefined;
            this.success = _data["success"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): ExportCollectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExportCollectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["success"] = this.success;
        data["error"] = this.error;
        return data;
    }
}

export interface IExportCollectionResponse {
    status?: UserCollectionExportTaskStatus | undefined;
    success?: boolean;
    error?: string | undefined;

    [key: string]: any;
}

export enum ExternalCollectionType {
    Csv = "Csv",
    UrzaGatherer = "UrzaGatherer",
}

export enum GameType {
    None = "None",
    Magic = "Magic",
    Pokemon = "Pokemon",
    Yugioh = "Yugioh",
    Lorcana = "Lorcana",
}

export class GetExportUserCollectionResultsResponse implements IGetExportUserCollectionResultsResponse {
    userId?: string | undefined;
    results?: UserCollectionExportTaskStatus2[] | undefined;
    success?: boolean;
    error?: string | undefined;

    [key: string]: any;

    constructor(data?: IGetExportUserCollectionResultsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.userId = _data["userId"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(UserCollectionExportTaskStatus2.fromJS(item));
            }
            this.success = _data["success"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): GetExportUserCollectionResultsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetExportUserCollectionResultsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["userId"] = this.userId;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["success"] = this.success;
        data["error"] = this.error;
        return data;
    }
}

export interface IGetExportUserCollectionResultsResponse {
    userId?: string | undefined;
    results?: UserCollectionExportTaskStatus2[] | undefined;
    success?: boolean;
    error?: string | undefined;

    [key: string]: any;
}

export class GetImportUserCollectionResultsResponse implements IGetImportUserCollectionResultsResponse {
    userId?: string | undefined;
    results?: UserCollectionImportTaskStatus2[] | undefined;
    success?: boolean;
    error?: string | undefined;

    [key: string]: any;

    constructor(data?: IGetImportUserCollectionResultsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.userId = _data["userId"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(UserCollectionImportTaskStatus2.fromJS(item));
            }
            this.success = _data["success"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): GetImportUserCollectionResultsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetImportUserCollectionResultsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["userId"] = this.userId;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["success"] = this.success;
        data["error"] = this.error;
        return data;
    }
}

export interface IGetImportUserCollectionResultsResponse {
    userId?: string | undefined;
    results?: UserCollectionImportTaskStatus2[] | undefined;
    success?: boolean;
    error?: string | undefined;

    [key: string]: any;
}

export class GetPredefinedTasksResponse implements IGetPredefinedTasksResponse {
    predefinedTasks?: PredefinedTask[] | undefined;
    success?: boolean;
    error?: string | undefined;

    [key: string]: any;

    constructor(data?: IGetPredefinedTasksResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["predefinedTasks"])) {
                this.predefinedTasks = [] as any;
                for (let item of _data["predefinedTasks"])
                    this.predefinedTasks!.push(PredefinedTask.fromJS(item));
            }
            this.success = _data["success"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): GetPredefinedTasksResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPredefinedTasksResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.predefinedTasks)) {
            data["predefinedTasks"] = [];
            for (let item of this.predefinedTasks)
                data["predefinedTasks"].push(item.toJSON());
        }
        data["success"] = this.success;
        data["error"] = this.error;
        return data;
    }
}

export interface IGetPredefinedTasksResponse {
    predefinedTasks?: PredefinedTask[] | undefined;
    success?: boolean;
    error?: string | undefined;

    [key: string]: any;
}

export class GetRecentTasksResponse implements IGetRecentTasksResponse {
    taskSummaries?: TaskSummary[] | undefined;
    success?: boolean;
    error?: string | undefined;

    [key: string]: any;

    constructor(data?: IGetRecentTasksResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["taskSummaries"])) {
                this.taskSummaries = [] as any;
                for (let item of _data["taskSummaries"])
                    this.taskSummaries!.push(TaskSummary.fromJS(item));
            }
            this.success = _data["success"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): GetRecentTasksResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecentTasksResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.taskSummaries)) {
            data["taskSummaries"] = [];
            for (let item of this.taskSummaries)
                data["taskSummaries"].push(item.toJSON());
        }
        data["success"] = this.success;
        data["error"] = this.error;
        return data;
    }
}

export interface IGetRecentTasksResponse {
    taskSummaries?: TaskSummary[] | undefined;
    success?: boolean;
    error?: string | undefined;

    [key: string]: any;
}

export class GetTaskHistoryResponse implements IGetTaskHistoryResponse {
    runs?: TaskRunSummary[] | undefined;
    start?: number | undefined;
    total?: number | undefined;
    success?: boolean;
    error?: string | undefined;

    [key: string]: any;

    constructor(data?: IGetTaskHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["runs"])) {
                this.runs = [] as any;
                for (let item of _data["runs"])
                    this.runs!.push(TaskRunSummary.fromJS(item));
            }
            this.start = _data["start"];
            this.total = _data["total"];
            this.success = _data["success"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): GetTaskHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaskHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.runs)) {
            data["runs"] = [];
            for (let item of this.runs)
                data["runs"].push(item.toJSON());
        }
        data["start"] = this.start;
        data["total"] = this.total;
        data["success"] = this.success;
        data["error"] = this.error;
        return data;
    }
}

export interface IGetTaskHistoryResponse {
    runs?: TaskRunSummary[] | undefined;
    start?: number | undefined;
    total?: number | undefined;
    success?: boolean;
    error?: string | undefined;

    [key: string]: any;
}

export class GetTaskRunEventsResponse implements IGetTaskRunEventsResponse {
    status?: NullableOfTaskStatusType | undefined;
    events?: TaskEvent[] | undefined;
    success?: boolean;
    error?: string | undefined;

    [key: string]: any;

    constructor(data?: IGetTaskRunEventsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.status = _data["status"];
            if (Array.isArray(_data["events"])) {
                this.events = [] as any;
                for (let item of _data["events"])
                    this.events!.push(TaskEvent.fromJS(item));
            }
            this.success = _data["success"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): GetTaskRunEventsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaskRunEventsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["status"] = this.status;
        if (Array.isArray(this.events)) {
            data["events"] = [];
            for (let item of this.events)
                data["events"].push(item.toJSON());
        }
        data["success"] = this.success;
        data["error"] = this.error;
        return data;
    }
}

export interface IGetTaskRunEventsResponse {
    status?: NullableOfTaskStatusType | undefined;
    events?: TaskEvent[] | undefined;
    success?: boolean;
    error?: string | undefined;

    [key: string]: any;
}

export class GetTaskRunResponse implements IGetTaskRunResponse {
    taskRun?: TaskRun | undefined;
    success?: boolean;
    error?: string | undefined;

    [key: string]: any;

    constructor(data?: IGetTaskRunResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.taskRun = _data["taskRun"] ? TaskRun.fromJS(_data["taskRun"]) : <any>undefined;
            this.success = _data["success"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): GetTaskRunResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaskRunResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["taskRun"] = this.taskRun ? this.taskRun.toJSON() : <any>undefined;
        data["success"] = this.success;
        data["error"] = this.error;
        return data;
    }
}

export interface IGetTaskRunResponse {
    taskRun?: TaskRun | undefined;
    success?: boolean;
    error?: string | undefined;

    [key: string]: any;
}

export class ImportCollectionRequest implements IImportCollectionRequest {
    artifactObjectKey!: string;
    game!: GameType;
    collectionType!: ExternalCollectionType;
    skipCollected!: boolean;
    importOther!: boolean;
    skipOther!: boolean;

    [key: string]: any;

    constructor(data?: IImportCollectionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.artifactObjectKey = _data["artifactObjectKey"];
            this.game = _data["game"];
            this.collectionType = _data["collectionType"];
            this.skipCollected = _data["skipCollected"];
            this.importOther = _data["importOther"];
            this.skipOther = _data["skipOther"];
        }
    }

    static fromJS(data: any): ImportCollectionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImportCollectionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["artifactObjectKey"] = this.artifactObjectKey;
        data["game"] = this.game;
        data["collectionType"] = this.collectionType;
        data["skipCollected"] = this.skipCollected;
        data["importOther"] = this.importOther;
        data["skipOther"] = this.skipOther;
        return data;
    }
}

export interface IImportCollectionRequest {
    artifactObjectKey: string;
    game: GameType;
    collectionType: ExternalCollectionType;
    skipCollected: boolean;
    importOther: boolean;
    skipOther: boolean;

    [key: string]: any;
}

export class ImportCollectionResponse implements IImportCollectionResponse {
    status?: UserCollectionImportTaskStatus | undefined;
    success?: boolean;
    error?: string | undefined;

    [key: string]: any;

    constructor(data?: IImportCollectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.status = _data["status"] ? UserCollectionImportTaskStatus.fromJS(_data["status"]) : <any>undefined;
            this.success = _data["success"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): ImportCollectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImportCollectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["success"] = this.success;
        data["error"] = this.error;
        return data;
    }
}

export interface IImportCollectionResponse {
    status?: UserCollectionImportTaskStatus | undefined;
    success?: boolean;
    error?: string | undefined;

    [key: string]: any;
}

export enum ItemType {
    None = "None",
    Card = "Card",
    Sealed = "Sealed",
}

export class ListTaskSchedulesResponse implements IListTaskSchedulesResponse {
    schedules?: TaskSchedule2[] | undefined;
    success?: boolean;
    error?: string | undefined;

    [key: string]: any;

    constructor(data?: IListTaskSchedulesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["schedules"])) {
                this.schedules = [] as any;
                for (let item of _data["schedules"])
                    this.schedules!.push(TaskSchedule2.fromJS(item));
            }
            this.success = _data["success"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): ListTaskSchedulesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListTaskSchedulesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.schedules)) {
            data["schedules"] = [];
            for (let item of this.schedules)
                data["schedules"].push(item.toJSON());
        }
        data["success"] = this.success;
        data["error"] = this.error;
        return data;
    }
}

export interface IListTaskSchedulesResponse {
    schedules?: TaskSchedule2[] | undefined;
    success?: boolean;
    error?: string | undefined;

    [key: string]: any;
}

export class MagicAdvancedSearchFile implements IMagicAdvancedSearchFile {
    convertedManaCost!: RangeParameter;
    cardSupertypes!: string[];
    cardTypes!: string[];
    cardSubtypes!: string[];
    rarities!: string[];
    power!: RangeParameter;
    toughness!: RangeParameter;
    releaseSet!: { [key: string]: string; };
    releaseYear!: RangeParameter;
    artists!: { [key: string]: string; };
    treatments!: { [key: string]: string; };
    value!: RangeParameter;
    legalities!: { [key: string]: string; };

    [key: string]: any;

    constructor(data?: IMagicAdvancedSearchFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.convertedManaCost = new RangeParameter();
            this.cardSupertypes = [];
            this.cardTypes = [];
            this.cardSubtypes = [];
            this.rarities = [];
            this.power = new RangeParameter();
            this.toughness = new RangeParameter();
            this.releaseSet = {};
            this.releaseYear = new RangeParameter();
            this.artists = {};
            this.treatments = {};
            this.value = new RangeParameter();
            this.legalities = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.convertedManaCost = _data["convertedManaCost"] ? RangeParameter.fromJS(_data["convertedManaCost"]) : new RangeParameter();
            if (Array.isArray(_data["cardSupertypes"])) {
                this.cardSupertypes = [] as any;
                for (let item of _data["cardSupertypes"])
                    this.cardSupertypes!.push(item);
            }
            if (Array.isArray(_data["cardTypes"])) {
                this.cardTypes = [] as any;
                for (let item of _data["cardTypes"])
                    this.cardTypes!.push(item);
            }
            if (Array.isArray(_data["cardSubtypes"])) {
                this.cardSubtypes = [] as any;
                for (let item of _data["cardSubtypes"])
                    this.cardSubtypes!.push(item);
            }
            if (Array.isArray(_data["rarities"])) {
                this.rarities = [] as any;
                for (let item of _data["rarities"])
                    this.rarities!.push(item);
            }
            this.power = _data["power"] ? RangeParameter.fromJS(_data["power"]) : new RangeParameter();
            this.toughness = _data["toughness"] ? RangeParameter.fromJS(_data["toughness"]) : new RangeParameter();
            if (_data["releaseSet"]) {
                this.releaseSet = {} as any;
                for (let key in _data["releaseSet"]) {
                    if (_data["releaseSet"].hasOwnProperty(key))
                        (<any>this.releaseSet)![key] = _data["releaseSet"][key];
                }
            }
            this.releaseYear = _data["releaseYear"] ? RangeParameter.fromJS(_data["releaseYear"]) : new RangeParameter();
            if (_data["artists"]) {
                this.artists = {} as any;
                for (let key in _data["artists"]) {
                    if (_data["artists"].hasOwnProperty(key))
                        (<any>this.artists)![key] = _data["artists"][key];
                }
            }
            if (_data["treatments"]) {
                this.treatments = {} as any;
                for (let key in _data["treatments"]) {
                    if (_data["treatments"].hasOwnProperty(key))
                        (<any>this.treatments)![key] = _data["treatments"][key];
                }
            }
            this.value = _data["value"] ? RangeParameter.fromJS(_data["value"]) : new RangeParameter();
            if (_data["legalities"]) {
                this.legalities = {} as any;
                for (let key in _data["legalities"]) {
                    if (_data["legalities"].hasOwnProperty(key))
                        (<any>this.legalities)![key] = _data["legalities"][key];
                }
            }
        }
    }

    static fromJS(data: any): MagicAdvancedSearchFile {
        data = typeof data === 'object' ? data : {};
        let result = new MagicAdvancedSearchFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["convertedManaCost"] = this.convertedManaCost ? this.convertedManaCost.toJSON() : <any>undefined;
        if (Array.isArray(this.cardSupertypes)) {
            data["cardSupertypes"] = [];
            for (let item of this.cardSupertypes)
                data["cardSupertypes"].push(item);
        }
        if (Array.isArray(this.cardTypes)) {
            data["cardTypes"] = [];
            for (let item of this.cardTypes)
                data["cardTypes"].push(item);
        }
        if (Array.isArray(this.cardSubtypes)) {
            data["cardSubtypes"] = [];
            for (let item of this.cardSubtypes)
                data["cardSubtypes"].push(item);
        }
        if (Array.isArray(this.rarities)) {
            data["rarities"] = [];
            for (let item of this.rarities)
                data["rarities"].push(item);
        }
        data["power"] = this.power ? this.power.toJSON() : <any>undefined;
        data["toughness"] = this.toughness ? this.toughness.toJSON() : <any>undefined;
        if (this.releaseSet) {
            data["releaseSet"] = {};
            for (let key in this.releaseSet) {
                if (this.releaseSet.hasOwnProperty(key))
                    (<any>data["releaseSet"])[key] = (<any>this.releaseSet)[key];
            }
        }
        data["releaseYear"] = this.releaseYear ? this.releaseYear.toJSON() : <any>undefined;
        if (this.artists) {
            data["artists"] = {};
            for (let key in this.artists) {
                if (this.artists.hasOwnProperty(key))
                    (<any>data["artists"])[key] = (<any>this.artists)[key];
            }
        }
        if (this.treatments) {
            data["treatments"] = {};
            for (let key in this.treatments) {
                if (this.treatments.hasOwnProperty(key))
                    (<any>data["treatments"])[key] = (<any>this.treatments)[key];
            }
        }
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        if (this.legalities) {
            data["legalities"] = {};
            for (let key in this.legalities) {
                if (this.legalities.hasOwnProperty(key))
                    (<any>data["legalities"])[key] = (<any>this.legalities)[key];
            }
        }
        return data;
    }
}

export interface IMagicAdvancedSearchFile {
    convertedManaCost: RangeParameter;
    cardSupertypes: string[];
    cardTypes: string[];
    cardSubtypes: string[];
    rarities: string[];
    power: RangeParameter;
    toughness: RangeParameter;
    releaseSet: { [key: string]: string; };
    releaseYear: RangeParameter;
    artists: { [key: string]: string; };
    treatments: { [key: string]: string; };
    value: RangeParameter;
    legalities: { [key: string]: string; };

    [key: string]: any;
}

export enum NullableOfTaskStatusType {
    Pending = "Pending",
    Running = "Running",
    Success = "Success",
    Failure = "Failure",
    Cancelled = "Cancelled",
}

export class PredefinedTask implements IPredefinedTask {
    id!: string;
    taskName!: string;
    definitionName!: string;
    taskSpecs!: string;
    timeoutSeconds!: number;

    [key: string]: any;

    constructor(data?: IPredefinedTask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.taskName = _data["taskName"];
            this.definitionName = _data["definitionName"];
            this.taskSpecs = _data["taskSpecs"];
            this.timeoutSeconds = _data["timeoutSeconds"];
        }
    }

    static fromJS(data: any): PredefinedTask {
        data = typeof data === 'object' ? data : {};
        let result = new PredefinedTask();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["taskName"] = this.taskName;
        data["definitionName"] = this.definitionName;
        data["taskSpecs"] = this.taskSpecs;
        data["timeoutSeconds"] = this.timeoutSeconds;
        return data;
    }
}

export interface IPredefinedTask {
    id: string;
    taskName: string;
    definitionName: string;
    taskSpecs: string;
    timeoutSeconds: number;

    [key: string]: any;
}

export class RangeParameter implements IRangeParameter {
    min!: number;
    max!: number;

    [key: string]: any;

    constructor(data?: IRangeParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.min = _data["min"];
            this.max = _data["max"];
        }
    }

    static fromJS(data: any): RangeParameter {
        data = typeof data === 'object' ? data : {};
        let result = new RangeParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["min"] = this.min;
        data["max"] = this.max;
        return data;
    }
}

export interface IRangeParameter {
    min: number;
    max: number;

    [key: string]: any;
}

export class RunTaskRequest implements IRunTaskRequest {
    taskName!: string;
    timeoutSeconds!: number;
    parametersJson!: string;

    [key: string]: any;

    constructor(data?: IRunTaskRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.taskName = _data["taskName"];
            this.timeoutSeconds = _data["timeoutSeconds"];
            this.parametersJson = _data["parametersJson"];
        }
    }

    static fromJS(data: any): RunTaskRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RunTaskRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["taskName"] = this.taskName;
        data["timeoutSeconds"] = this.timeoutSeconds;
        data["parametersJson"] = this.parametersJson;
        return data;
    }
}

export interface IRunTaskRequest {
    taskName: string;
    timeoutSeconds: number;
    parametersJson: string;

    [key: string]: any;
}

export class RunTaskResponse implements IRunTaskResponse {
    taskGuid?: string | undefined;
    success?: boolean;
    error?: string | undefined;

    [key: string]: any;

    constructor(data?: IRunTaskResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.taskGuid = _data["taskGuid"];
            this.success = _data["success"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): RunTaskResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RunTaskResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["taskGuid"] = this.taskGuid;
        data["success"] = this.success;
        data["error"] = this.error;
        return data;
    }
}

export interface IRunTaskResponse {
    taskGuid?: string | undefined;
    success?: boolean;
    error?: string | undefined;

    [key: string]: any;
}

export class SavePredefinedTaskRequest implements ISavePredefinedTaskRequest {
    taskName!: string;
    definitionName!: string;
    taskParametersJson!: string;
    timeoutSeconds!: number;

    [key: string]: any;

    constructor(data?: ISavePredefinedTaskRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.taskName = _data["taskName"];
            this.definitionName = _data["definitionName"];
            this.taskParametersJson = _data["taskParametersJson"];
            this.timeoutSeconds = _data["timeoutSeconds"];
        }
    }

    static fromJS(data: any): SavePredefinedTaskRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SavePredefinedTaskRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["taskName"] = this.taskName;
        data["definitionName"] = this.definitionName;
        data["taskParametersJson"] = this.taskParametersJson;
        data["timeoutSeconds"] = this.timeoutSeconds;
        return data;
    }
}

export interface ISavePredefinedTaskRequest {
    taskName: string;
    definitionName: string;
    taskParametersJson: string;
    timeoutSeconds: number;

    [key: string]: any;
}

export class TaskDescription implements ITaskDescription {
    taskName!: string;
    parametersJson!: string;
    predefined?: PredefinedTask[] | undefined;

    [key: string]: any;

    constructor(data?: ITaskDescription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.taskName = _data["taskName"];
            this.parametersJson = _data["parametersJson"];
            if (Array.isArray(_data["predefined"])) {
                this.predefined = [] as any;
                for (let item of _data["predefined"])
                    this.predefined!.push(PredefinedTask.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskDescription {
        data = typeof data === 'object' ? data : {};
        let result = new TaskDescription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["taskName"] = this.taskName;
        data["parametersJson"] = this.parametersJson;
        if (Array.isArray(this.predefined)) {
            data["predefined"] = [];
            for (let item of this.predefined)
                data["predefined"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITaskDescription {
    taskName: string;
    parametersJson: string;
    predefined?: PredefinedTask[] | undefined;

    [key: string]: any;
}

export class TaskDescription2 implements ITaskDescription2 {
    taskName!: string;
    parametersJson!: string;
    predefined?: PredefinedTask[] | undefined;

    [key: string]: any;

    constructor(data?: ITaskDescription2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.taskName = _data["taskName"];
            this.parametersJson = _data["parametersJson"];
            if (Array.isArray(_data["predefined"])) {
                this.predefined = [] as any;
                for (let item of _data["predefined"])
                    this.predefined!.push(PredefinedTask.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskDescription2 {
        data = typeof data === 'object' ? data : {};
        let result = new TaskDescription2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["taskName"] = this.taskName;
        data["parametersJson"] = this.parametersJson;
        if (Array.isArray(this.predefined)) {
            data["predefined"] = [];
            for (let item of this.predefined)
                data["predefined"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITaskDescription2 {
    taskName: string;
    parametersJson: string;
    predefined?: PredefinedTask[] | undefined;

    [key: string]: any;
}

export class TaskEvent implements ITaskEvent {
    id!: string;
    type!: TaskEventType;
    at!: Date;
    message!: string;

    [key: string]: any;

    constructor(data?: ITaskEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.type = _data["type"];
            this.at = _data["at"] ? new Date(_data["at"].toString()) : <any>undefined;
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): TaskEvent {
        data = typeof data === 'object' ? data : {};
        let result = new TaskEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["type"] = this.type;
        data["at"] = this.at ? this.at.toISOString() : <any>undefined;
        data["message"] = this.message;
        return data;
    }
}

export interface ITaskEvent {
    id: string;
    type: TaskEventType;
    at: Date;
    message: string;

    [key: string]: any;
}

export enum TaskEventType {
    Info = "Info",
    Warning = "Warning",
    Error = "Error",
}

export class TaskResponse implements ITaskResponse {
    success?: boolean;
    error?: string | undefined;

    [key: string]: any;

    constructor(data?: ITaskResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.success = _data["success"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): TaskResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["success"] = this.success;
        data["error"] = this.error;
        return data;
    }
}

export interface ITaskResponse {
    success?: boolean;
    error?: string | undefined;

    [key: string]: any;
}

export class TaskRun implements ITaskRun {
    taskId!: string;
    taskName!: string;
    taskProperties!: string;
    startedAt!: Date;
    startedBy!: string;
    status!: TaskStatusType;

    [key: string]: any;

    constructor(data?: ITaskRun) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.taskId = _data["taskId"];
            this.taskName = _data["taskName"];
            this.taskProperties = _data["taskProperties"];
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : <any>undefined;
            this.startedBy = _data["startedBy"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): TaskRun {
        data = typeof data === 'object' ? data : {};
        let result = new TaskRun();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["taskId"] = this.taskId;
        data["taskName"] = this.taskName;
        data["taskProperties"] = this.taskProperties;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : <any>undefined;
        data["startedBy"] = this.startedBy;
        data["status"] = this.status;
        return data;
    }
}

export interface ITaskRun {
    taskId: string;
    taskName: string;
    taskProperties: string;
    startedAt: Date;
    startedBy: string;
    status: TaskStatusType;

    [key: string]: any;
}

export class TaskRunSummary implements ITaskRunSummary {
    id!: string;
    start!: Date;
    duration?: number | undefined;
    status!: TaskStatusType;

    [key: string]: any;

    constructor(data?: ITaskRunSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): TaskRunSummary {
        data = typeof data === 'object' ? data : {};
        let result = new TaskRunSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["status"] = this.status;
        return data;
    }
}

export interface ITaskRunSummary {
    id: string;
    start: Date;
    duration?: number | undefined;
    status: TaskStatusType;

    [key: string]: any;
}

export class TaskSchedule implements ITaskSchedule {
    id!: string;
    taskName!: string;
    definitionName!: string;
    cronSchedule!: string;
    enabled!: boolean;

    [key: string]: any;

    constructor(data?: ITaskSchedule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.taskName = _data["taskName"];
            this.definitionName = _data["definitionName"];
            this.cronSchedule = _data["cronSchedule"];
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): TaskSchedule {
        data = typeof data === 'object' ? data : {};
        let result = new TaskSchedule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["taskName"] = this.taskName;
        data["definitionName"] = this.definitionName;
        data["cronSchedule"] = this.cronSchedule;
        data["enabled"] = this.enabled;
        return data;
    }
}

export interface ITaskSchedule {
    id: string;
    taskName: string;
    definitionName: string;
    cronSchedule: string;
    enabled: boolean;

    [key: string]: any;
}

export class TaskSchedule2 implements ITaskSchedule2 {
    id!: string;
    taskName!: string;
    definitionName!: string;
    cronSchedule!: string;
    enabled!: boolean;

    [key: string]: any;

    constructor(data?: ITaskSchedule2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.taskName = _data["taskName"];
            this.definitionName = _data["definitionName"];
            this.cronSchedule = _data["cronSchedule"];
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): TaskSchedule2 {
        data = typeof data === 'object' ? data : {};
        let result = new TaskSchedule2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["taskName"] = this.taskName;
        data["definitionName"] = this.definitionName;
        data["cronSchedule"] = this.cronSchedule;
        data["enabled"] = this.enabled;
        return data;
    }
}

export interface ITaskSchedule2 {
    id: string;
    taskName: string;
    definitionName: string;
    cronSchedule: string;
    enabled: boolean;

    [key: string]: any;
}

export enum TaskStatusType {
    Pending = "Pending",
    Running = "Running",
    Success = "Success",
    Failure = "Failure",
    Cancelled = "Cancelled",
}

export class TaskSummary implements ITaskSummary {
    task!: string;
    recent?: TaskRunSummary[] | undefined;

    [key: string]: any;

    constructor(data?: ITaskSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.task = _data["task"];
            if (Array.isArray(_data["recent"])) {
                this.recent = [] as any;
                for (let item of _data["recent"])
                    this.recent!.push(TaskRunSummary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskSummary {
        data = typeof data === 'object' ? data : {};
        let result = new TaskSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["task"] = this.task;
        if (Array.isArray(this.recent)) {
            data["recent"] = [];
            for (let item of this.recent)
                data["recent"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITaskSummary {
    task: string;
    recent?: TaskRunSummary[] | undefined;

    [key: string]: any;
}

export class UpdateTaskScheduleRequest implements IUpdateTaskScheduleRequest {
    scheduleId!: string;
    cronSchedule?: string | undefined;
    enabled?: boolean | undefined;

    [key: string]: any;

    constructor(data?: IUpdateTaskScheduleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.scheduleId = _data["scheduleId"];
            this.cronSchedule = _data["cronSchedule"];
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): UpdateTaskScheduleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTaskScheduleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["scheduleId"] = this.scheduleId;
        data["cronSchedule"] = this.cronSchedule;
        data["enabled"] = this.enabled;
        return data;
    }
}

export interface IUpdateTaskScheduleRequest {
    scheduleId: string;
    cronSchedule?: string | undefined;
    enabled?: boolean | undefined;

    [key: string]: any;
}

export class UserCollectionExportTaskStatus implements IUserCollectionExportTaskStatus {
    id!: string;
    startedAt!: Date;
    isPending!: boolean;
    isSuccess!: boolean;
    result?: CollectionExportResult | undefined;

    [key: string]: any;

    constructor(data?: IUserCollectionExportTaskStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : <any>undefined;
            this.isPending = _data["isPending"];
            this.isSuccess = _data["isSuccess"];
            this.result = _data["result"] ? CollectionExportResult.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserCollectionExportTaskStatus {
        data = typeof data === 'object' ? data : {};
        let result = new UserCollectionExportTaskStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : <any>undefined;
        data["isPending"] = this.isPending;
        data["isSuccess"] = this.isSuccess;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserCollectionExportTaskStatus {
    id: string;
    startedAt: Date;
    isPending: boolean;
    isSuccess: boolean;
    result?: CollectionExportResult | undefined;

    [key: string]: any;
}

export class UserCollectionExportTaskStatus2 implements IUserCollectionExportTaskStatus2 {
    id!: string;
    startedAt!: Date;
    isPending!: boolean;
    isSuccess!: boolean;
    result?: CollectionExportResult | undefined;

    [key: string]: any;

    constructor(data?: IUserCollectionExportTaskStatus2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : <any>undefined;
            this.isPending = _data["isPending"];
            this.isSuccess = _data["isSuccess"];
            this.result = _data["result"] ? CollectionExportResult.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserCollectionExportTaskStatus2 {
        data = typeof data === 'object' ? data : {};
        let result = new UserCollectionExportTaskStatus2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : <any>undefined;
        data["isPending"] = this.isPending;
        data["isSuccess"] = this.isSuccess;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserCollectionExportTaskStatus2 {
    id: string;
    startedAt: Date;
    isPending: boolean;
    isSuccess: boolean;
    result?: CollectionExportResult | undefined;

    [key: string]: any;
}

export class UserCollectionImportTaskStatus implements IUserCollectionImportTaskStatus {
    id!: string;
    startedAt!: Date;
    isPending!: boolean;
    isSuccess!: boolean;
    result?: CollectionImportResult | undefined;

    [key: string]: any;

    constructor(data?: IUserCollectionImportTaskStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : <any>undefined;
            this.isPending = _data["isPending"];
            this.isSuccess = _data["isSuccess"];
            this.result = _data["result"] ? CollectionImportResult.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserCollectionImportTaskStatus {
        data = typeof data === 'object' ? data : {};
        let result = new UserCollectionImportTaskStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : <any>undefined;
        data["isPending"] = this.isPending;
        data["isSuccess"] = this.isSuccess;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserCollectionImportTaskStatus {
    id: string;
    startedAt: Date;
    isPending: boolean;
    isSuccess: boolean;
    result?: CollectionImportResult | undefined;

    [key: string]: any;
}

export class UserCollectionImportTaskStatus2 implements IUserCollectionImportTaskStatus2 {
    id!: string;
    startedAt!: Date;
    isPending!: boolean;
    isSuccess!: boolean;
    result?: CollectionImportResult | undefined;

    [key: string]: any;

    constructor(data?: IUserCollectionImportTaskStatus2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : <any>undefined;
            this.isPending = _data["isPending"];
            this.isSuccess = _data["isSuccess"];
            this.result = _data["result"] ? CollectionImportResult.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserCollectionImportTaskStatus2 {
        data = typeof data === 'object' ? data : {};
        let result = new UserCollectionImportTaskStatus2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : <any>undefined;
        data["isPending"] = this.isPending;
        data["isSuccess"] = this.isSuccess;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserCollectionImportTaskStatus2 {
    id: string;
    startedAt: Date;
    isPending: boolean;
    isSuccess: boolean;
    result?: CollectionImportResult | undefined;

    [key: string]: any;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}